import { writable } from "svelte/store"
import { push } from "svelte-spa-router"

export const targetSetId = writable("")
export const vocabularySetId = writable("")
export const questionnaireSetId = writable("")
export const targetWords = writable([])

function idCheck() {
  // MEMO: マーケティング会社との連携のため、一旦利用者番号のチェックは無効化
  return true

  // if (!sessionStorage.getItem("id")) {
  //   alert("利用者番号が入力されていません")
  //   push("/")
  // }
}

export function whenScreenTransitionFunc() {
  idCheck()
  scrollTo(0, 0)
}

document.addEventListener(
  "dblclick",
  function (e) {
    e.preventDefault()
  },
  { passive: false }
)
